import { MessageBuilder } from './message-builder';

/**
 * A convenience type for getting the message type from a message definition.
 * This allows specifying subscriber types when they're not inlined in the
 * `topic.on` call.
 */

export function defineMessage(spec) {
  var _spec$reply;
  const commonProps = {
    type: spec.type,
    replyType: (_spec$reply = spec.reply) === null || _spec$reply === void 0 ? void 0 : _spec$reply.getType()
  };
  return {
    spec,
    create: typeof spec.payloadSchema === 'undefined' ? () => new MessageBuilder(Object.assign({}, commonProps, {
      payloadSchema: undefined
    })) : payload => new MessageBuilder(Object.assign({}, commonProps, {
      payload,
      payloadSchema: spec.payloadSchema
    })),
    getType: () => spec.type
  };
}